import { useEffect, useState } from "react";
import LawFirmProfileSteps from "./LawFirmProfileSteps";
import LawFirmMatches from "./LawFirmMatches";
import LawFirmProfile from "./LawFirmProfile";
import { useFormik } from "formik";
import { lawFirmInfoSchema } from "../../Validations/User";
import { useContext } from "react";
import { Context } from "../../Context/Context";
import { checkIfFirmClaimedApi, DEFAULTAVATAR, searchFirmApi, updateUserProfessionalApi, outreachInviteApi, updateUserApi, DEFAULT_STATE } from "../../Constants";
import { readFirmInvite, clearFirmInvite } from "./firmInvite";
import { toast } from "react-toastify";
import { FIRMAPPROVELIST, UNAPPROVELIST } from "../../Constants";
import { useNavigate } from "react-router-dom";

function CompleteLawFirmProfile({setShowEdit, noSteps= false}) {
    // const [lawFirmId, setLawFirmId] = useState(null);
    const [matchingFirms, setMatchingFirms] = useState([]);
    // firm from an outreach "Claim your firm" link, pre-selected in the claim step
    const [inviteFirm, setInviteFirm] = useState(null);
    const navigate = useNavigate();
    const {userDetails, makeApiCallFunc, setUpdateLoggedinData} = useContext(Context);
    // optional case-type preference (saved straight to the account - no admin review needed)
    const [casePref, setCasePref] = useState(Array.isArray(userDetails?.casePref) ? userDetails.casePref : []);
    const handleContinue = () => {
                            window.scrollTo(0, 0);
        if(!noSteps) setStep(2);
    };
  const onSubmission = () => {
    userUpdation();
  }
     const onSubmit = () => {
        searchFirmInDb();
      }
      const searchFirmInDb = () => {
        makeApiCallFunc(searchFirmApi, {
          firmName: values.company,
          firmWebsite: values.lawFirmLink,
        }, (response) => {
                    const found = Array.isArray(response?.data) ? response.data : [];
                    const list = inviteFirm && !found.some((f) => f._id === inviteFirm._id) ? [inviteFirm, ...found] : found;
                    setMatchingFirms(list);
                    if(inviteFirm && !values.lawFirmId)
                    {
                        setFieldValue("lawFirmId", inviteFirm._id);
                    }
                    else if(list.length === 0)
                    {
                        setFieldValue("lawFirmId", null);
                    }
                    //assign first one
                    // setLawFirmId(response?.data[0]?._id || null);
                    if(!noSteps) setStep(2);
                },
                (error) => {
                    console.error("Error searching firms:", error);
                },
                null,
                false,
                true
        );
      }
    
  const approveData = (values) => {
      const data = {};

      FIRMAPPROVELIST.map((item) => { 
        console.log(item, values[item],userDetails[item]);

          if(values[item] !== userDetails[item])
          {
              data[item] = {
                "newValue" : values[item] ? values[item] : null,
                "oldValue" : userDetails[item]
              }
          }
      });
      
      console.log(data)
      return data;
  }

  const userUpdation = () => {

    if(values.lawFirmId && values.lawFirmId !== null && values.lawFirmId !== userDetails?.lawFirmId)
    {
        //check if selected firm is already with another user
        makeApiCallFunc(checkIfFirmClaimedApi, {firmId: values.lawFirmId}, (response) => {
            if(response?.data?.claimed)
            {
                    toast.error("This firm is already claimed by another user. Please select a different firm or update your firm information.");
                    return;
                
            }
            else
            {
                
                updateUserInfo();
            }
        },
            (error) => {
                console.error("Error checking firm claim status:", error);
                toast.error("Error checking firm claim status. Please try again.");
            });
    }
   else
   {
        updateUserInfo();
   }
  }
  const updateUserInfo = () => {
     const valuestoSubmit = values;
    
    if(values.lawFirmId && values.lawFirmId !== null && values.lawFirmId !== userDetails?.lawFirmId)
    {
        const firmValues = matchingFirms.find(firm => firm._id === values.lawFirmId);
        valuestoSubmit.lawFirmLink = firmValues?.website;    
        valuestoSubmit.company = firmValues?.name;
        valuestoSubmit.phoneNumber = firmValues?.phone?.replace(/\D/g, "");
        valuestoSubmit.lawFirmId = values.lawFirmId;
    }
    const approvePostData = approveData(valuestoSubmit);
    if (!noSteps) {
      makeApiCallFunc(updateUserApi, { user: userDetails._id, casePref, statePref: [DEFAULT_STATE] },
        () => {}, (e) => console.log(e), null, true);
    }
     makeApiCallFunc(
      updateUserProfessionalApi, 
      {
        toBeApproved : Object.entries(approvePostData)?.length ? {...approvePostData, profilePic: '',user: userDetails._id, "isUserAssistant": false} : null,
        user: userDetails._id,
    },
      ({data}) => {
          toast.success("Sent the updated information to admin for approval");
          setUpdateLoggedinData(prev => !prev);
          // setShowEdit only exists when this form is opened from the profile page;
          // on /attorney/profileCompletion it's undefined and calling it threw,
          // so the page never moved on after "Submit for Verification".
          if (typeof setShowEdit === "function") setShowEdit(false);
          // outreach invite used - mark it and forget it
          const invite = readFirmInvite();
          if (invite) {
            makeApiCallFunc(outreachInviteApi + invite + "/redeem", {}, () => {}, () => {}, null, true);
            clearFirmInvite();
          }
          window.scrollTo(0, 0);
          // first submission -> straight to the case dashboard (the "under review"
          // popup there shows the cases clients saved for this firm);
          // edits from the profile page stay on the profile
          navigate(noSteps ? "/attorney/profile" : "/attorney/casesFeed/availableCases"); 

      }
       
      
      )
    }
    const [step, setStep] = useState(1);
       const initialValue = {
    firstName :userDetails?.firstName ? userDetails?.firstName : "",
    email: userDetails?.email ? userDetails?.email : "",
    lastName :userDetails?.lastName ? userDetails?.lastName : "",
    lawFirmLink: userDetails?.lawFirmLink ? userDetails?.lawFirmLink : "",
    company: userDetails?.company ? userDetails?.company : "",
    phoneNumber: userDetails?.phoneNumber ? userDetails?.phoneNumber : "",
    lawFirmId: userDetails?.lawFirmId ? userDetails?.lawFirmId : "",
}
   const {values, errors, touched, handleBlur, setFieldValue,handleChange, handleSubmit, isSubmitting} = useFormik({
      enableReinitialize: true,
      initialValues : initialValue,
      validationSchema : lawFirmInfoSchema,
      onSubmit,
  })

    // Came from an outreach email: load that firm and fill in what we know
    useEffect(() => {
        const invite = readFirmInvite();
        if (!invite || userDetails?.lawFirmId) return;
        makeApiCallFunc(outreachInviteApi + invite, null,
            ({data}) => {
                const firm = data?.firm;
                if (!firm?._id) { clearFirmInvite(); return; }
                setInviteFirm(firm);
                if (!values.company) setFieldValue("company", firm.name || "");
                if (!values.lawFirmLink && firm.website) setFieldValue("lawFirmLink", firm.website);
                if (!values.phoneNumber && firm.phone) setFieldValue("phoneNumber", String(firm.phone).replace(/\D/g, ""));
            },
            () => clearFirmInvite(),
            null, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
   

    return (
        <>
        {
            setShowEdit && <div className="flex mt-2 lg:pt-8 lg:pb-4 lg:px-20 justify-between items-center px-2  w-full mb-2">
                <div className="text-navy text-lg lg:text-xl py-2 font-bold font-spectral">
                    Edit Your Law Firm Profile
                </div>
                <button className="border border-tan text-tan hover:bg-cream font-semibold px-4 py-2 text-xs rounded transition-colors" onClick={() => setShowEdit(false)}>Close</button>
            </div>
        }
        {
            noSteps ? (
                <div className="w-full border-t px-2 lg:px-10">
                <LawFirmProfile
                     values={values}
                     errors={errors}
                     touched={touched}
                        handleBlur={handleBlur} 
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        handleSubmit={onSubmission}
                        buttonLabel="Submit"
                        disableFirmSelection={true}
                    />
                    </div>
            ) : 
            <>
            {step === 1 && (
                <LawFirmProfileSteps
                    step={1}
                    title="Complete Your Law Firm Profile"
                    description="Enter your information so we can verify your law firm."
                    // onNext={handleContinue}
                >
                    <LawFirmProfile 
                     values={values}
                     errors={errors}
                     touched={touched}
                    handleBlur={handleBlur} 
                    handleChange={handleChange}
                    setFieldValue={setFieldValue}
                    handleSubmit={handleSubmit}
                    casePref={casePref}
                    setCasePref={setCasePref}
                    />
                </LawFirmProfileSteps>
            )}

            {step === 2 &&  (
                <LawFirmProfileSteps
                    step={2}
                    title="Claim Your Firm"
                    description="We found the following potential matches. Claim your law firm, or continue if none are correct."
                    onBack={() => 
                        {
                            window.scrollTo(0, 0);
                            setStep(1)
                        }}
                    onNext={onSubmission}
                    nextLabel="Submit for Verification"
                    backLabel="Edit Law Firm Info"
                >
                    <LawFirmMatches 
                      matchingFirms={matchingFirms}
                      values={values}
                      setFieldValue={setFieldValue}
                    />
                </LawFirmProfileSteps>
            )}
            </>
            }
        </>
    );
}
export default CompleteLawFirmProfile;